import { Component, Vue } from 'vue-property-decorator';
import dayjs from 'dayjs';
import template from './Plans.vue';
import store from '@/store';
import plans from '@/store/modules/plans';
import filters from '@/_helpers/filters';
import customer from '@/store/modules/customer';
import payment from '@/store/modules/payment';
import { router } from '@/_helpers';

@Component({
	mixins: [template],
	methods: {
		formatBytes: filters.formatBytes,
		formatNumber: filters.formatNumber,
		formatScans: filters.formatScans,
		formatSupport: filters.formatSupport
	}
})
export default class Plans extends Vue {
	chosenPlan: boolean = false;

	confirmationPopup: boolean = false;

	confirmationPopupInfo: string = '';

	selectedPlanId: string | null = null;

	yearlyPayment: boolean = false;

	loading: boolean = false;

	progress: any = null;

	formattedPlans: any = [[], []];

	hasError: boolean = false;

	errorMessage: string = '';

	get automaticPaymentEnabled(): boolean {
		const paymentMethods = payment.payments;

		let defaultSelected = false;

		for (let i = 0; i < paymentMethods.length; i += 1) {
			if (paymentMethods[i].isDefault) defaultSelected = true;
		}

		return defaultSelected;
	}

	async mounted(): Promise<Promise<void>> {
		this.loading = true;

		this.progress = await this.getProgress();
		if (this.progress.permissionToPay) {
			// Customer already paying, redirect.
			router.push({ name: 'overview' });
			store.commit('openNotifier', {
				text: `Geen toegang tot deze pagina.`,
				color: 'error'
			});
		}

		try {
			const plansResp = await plans.getPlans();
			const planss = plansResp.data;
			const productsResp = await plans.getProducts();
			let products = productsResp.data;
			const formattedPlans: any = [[], []];

			products = products.filter((product: any) => {
				return product.type === 'plan' && !product.isEnterprise;
			});

			planss.forEach((plan: any) => {
				products.forEach((product: any) => {
					if (plan.productId === product.id) {
						const p = {
							id: plan.id,
							price: plan.price,
							interval: plan.interval,
							name: product.name,
							meta: {
								qrCodes: product.qrCodes,
								scans: product.scans,
								storage: product.storage,
								users: product.users,
								premiumSupport: product.premiumSupport
							}
						};

						if (plan.active) {
							if (plan.interval === 'month') {
								formattedPlans[0].push(p);
							} else {
								formattedPlans[1].push(p);
							}
						}
					}
				});
			});

			// Monthly
			this.formattedPlans[0] = formattedPlans[0].sort((a: any, b: any) => b.price - a.price);

			// Yearly
			this.formattedPlans[1] = formattedPlans[1].sort((a: any, b: any) => b.price - a.price);
		} catch (error) {
			store.commit('openNotifier', {
				text: `Er ging wat fout tijdens het ophalen van de pakketten`,
				color: 'error'
			});
		} finally {
			this.loading = false;
		}
	}

	public get daysLeft(): number {
		if (!this.progress) return 0;

		const currentDate = dayjs();
		const endDate = dayjs(this.progress.trialEndAt);

		return endDate.diff(currentDate, 'd');
	}

	async getProgress(): Promise<any> {
		try {
			const progress = await customer.getProgress();
			return progress;
		} catch (error) {
			store.commit('openNotifier', {
				text: `Er ging wat fout tijdens het ophalen van de voortganggegevens`,
				color: 'error'
			});
		}

		return null;
	}

	async activate() {
		const planId = this.selectedPlanId;

		if (!planId) return; // TODO: Unlikely, but show error.

		this.loading = true;

		try {
			await customer.activate({ planId });
			store.commit('openNotifier', {
				text: `Het pakket is succesvol gekozen`,
				color: 'success'
			});
			this.chosenPlan = true;
			this.confirmationPopup = false;
		} catch (error) {
			this.setError(error);
			store.commit('openNotifier', {
				text: `Er ging wat fout tijdens het selecteren van het pakket`,
				color: 'error'
			});
		} finally {
			this.loading = false;
		}
	}

	setError(error: any): void {
		this.hasError = true;
		switch (error.data.errors[0].code) {
			case 'incorrect_status':
			default:
				this.errorMessage = error.data.errors[0].detail;
				break;
		}
	}

	selectPlan(plan: any) {
		let interval;

		switch (plan.interval) {
			case 'month':
				interval = 'maand';
				break;
			case 'year':
				interval = 'jaar';
				break;
			default:
				interval = 'maand';
				break;
		}

		this.confirmationPopup = true;
		this.confirmationPopupInfo = `Weet je zeker dat je pakket <b>${plan.name}</b> wil kopen voor <b>€${plan.price /
			100},- per ${interval}</b>?`;
		this.selectedPlanId = plan.id;
	}
}
